import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: "text.secondary" }} />,
    title: "Streamlined Configuration",
    description:
      "Easily configure and customize workflows to align with your IT service management processes.",
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: "text.secondary" }} />,
    title: "Robust Reliability",
    description:
      "Ensure consistent and dependable performance to support critical IT operations.",
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: "text.secondary" }} />,
    title: "Enhanced User Satisfaction",
    description:
      "Deliver exceptional service experiences with an intuitive interface and responsive support.",
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: "text.secondary" }} />,
    title: "Innovative Automation",
    description:
      "Leverage advanced automation to reduce manual effort and improve efficiency in IT service delivery.",
  },
];

export default function SignInContent() {
  const theme = useTheme();

  const logoUrl =
    theme.palette.mode === "dark"
      ? "/adaptixLogoDark.png"
      : "/adaptixLogoLight.png";
  return (
    <Stack
      sx={{
        flexDirection: "column",
        alignSelf: "center",
        gap: 1,
        maxWidth: 450,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={process.env.PUBLIC_URL + logoUrl}
          alt="Company Logo"
          style={{ height: "200px", width: "200px" }}
        />
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: "medium" }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
